import api, { adminApiPrefix } from './Api';
import {
  Popup,
  popupFromResponse,
  popupToUpsertRequest,
} from '../interfaces/Popup/Popup';
import { MediaOptions } from '../interfaces/MediaOptions';

const popupAdminApiPrefix = `${adminApiPrefix}/popups`;

export const createPopup = async (popup: Popup): Promise<Popup> => {
  const response = await api.post(
    `${popupAdminApiPrefix}`,
    popupToUpsertRequest(popup),
  );

  return popupFromResponse(response.data?.data);
};

export const getPopups = async (): Promise<Popup[]> => {
  const response = await api.get(popupAdminApiPrefix, {
    params: { 'include-inactive': true },
  });

  return (response.data?.data ?? []).map(popupFromResponse);
};

export const getPopup = async (id: number): Promise<Popup> => {
  const response = await api.get(`${popupAdminApiPrefix}/${id}`);

  return popupFromResponse(response.data?.data);
};

export const updatePopup = async (popup: Popup): Promise<Popup> => {
  const response = await api.put(
    `${popupAdminApiPrefix}/${popup.id}`,
    popupToUpsertRequest(popup),
  );

  return popupFromResponse(response.data?.data);
};

export const updatePopupMedia = async (
  id: number,
  media: MediaOptions,
): Promise<void> => {
  const bodyFormData = new FormData();

  if (media.image) {
    bodyFormData.append('image', media.image);
  }

  if (media.eraseImage) {
    bodyFormData.append('erase-image', '1');
  }

  return api.put(`${popupAdminApiPrefix}/media/${id}`, bodyFormData);
};

export const deletePopup = async (id: number): Promise<void> =>
  api.delete(`${popupAdminApiPrefix}/${id}`);
